import {
	AUDIO_GROUP_TYPE,
	COLLECTION_IDS,
	COLLECTION_NAMES,
	COLLECTION_SLUGS,
} from "../../models/dictionary";
import type { CollectionModel } from "../../models/models";

export const collections: CollectionModel[] = [
	{
		id: COLLECTION_IDS.BLEND,
		name: COLLECTION_NAMES.BLEND,
		slug: COLLECTION_SLUGS.BLEND,
		type: AUDIO_GROUP_TYPE.COLLECTION,
		imageUrlStub: "https://images.coffitivity.com/blend",
		description:
			"Custom curated soundscapes that blend music, nature, and ambient sounds. These tracks are designed to create a harmonious atmosphere for relaxation, focus, or inspiration.",
	},
	{
		id: COLLECTION_IDS.BRAIN_WAVE,
		name: COLLECTION_NAMES.BRAIN_WAVE,
		slug: COLLECTION_SLUGS.BRAIN_WAVE,
		type: AUDIO_GROUP_TYPE.COLLECTION,
		imageUrlStub: "https://images.coffitivity.com/brain-wave",
		description:
			"Enhance your cognitive flow with brainwave-boosting audio. Designed to support focus, creativity, and relaxation, these scientifically informed tracks use binaural beats and rhythmic patterns to optimize your mental state.",
	},
	{
		id: COLLECTION_IDS.CAFE,
		name: COLLECTION_NAMES.CAFE,
		slug: COLLECTION_SLUGS.CAFE,
		type: AUDIO_GROUP_TYPE.COLLECTION,
		imageUrlStub: "https://images.coffitivity.com/cafe",
		description:
			"Bring the buzz of your favorite café to your workspace. From quiet neighborhood coffee shops to bustling urban espresso bars, these soundscapes recreate the perfect café ambiance to boost creativity and focus.",
	},
	{
		id: COLLECTION_IDS.MOODSCAPE,
		name: COLLECTION_NAMES.MOODSCAPE,
		slug: COLLECTION_SLUGS.MOODSCAPE,
		type: AUDIO_GROUP_TYPE.COLLECTION,
		imageUrlStub: "https://images.coffitivity.com/moodscape",
		description:
			"Ethereal sounds evoke feelings of dreaminess, spaciousness, and a touch of the surreal. These sounds are perfect for helping you drift, reflect, or create in imaginative headspace.",
	},
	{
		id: COLLECTION_IDS.SOUNDSCAPE,
		name: COLLECTION_NAMES.SOUNDSCAPE,
		slug: COLLECTION_SLUGS.SOUNDSCAPE,
		type: AUDIO_GROUP_TYPE.COLLECTION,
		imageUrlStub: "https://images.coffitivity.com/soundscape",
		description:
			"Immerse yourself in the worlds most soothing and inspiring environments. From tranquil forests to lively city streets, these ambient recordings transport you to places that enhance relaxation, mindfulness, and deep focus.",
	},
	{
		id: COLLECTION_IDS.SOUND_COLOR,
		name: COLLECTION_NAMES.SOUND_COLOR,
		slug: COLLECTION_SLUGS.SOUND_COLOR,
		type: AUDIO_GROUP_TYPE.COLLECTION,
		imageUrlStub: "https://images.coffitivity.com/sound-color",
		description:
			"Experience the science of sound with white noise, pink noise, and other sonic textures. Perfect for relaxation, deep concentration, and blocking out distractions, these tonal atmospheres help you create the ideal audio environment.",
	},
];
